export default __webpack_public_path__ + "static/media/ourclient8.5371f7cf.png";